import type { FeatureToggles } from '@/features/featureToggle/types/featureToggle'

export const FEATURE_TOGGLES: FeatureToggles = {
  toggles: [
    {
      name: 'PORTFOLIO_HIERARCHY_PAGE_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEXPORTAL_EXAMPLE_FEATURE_ENABLED',
      enabled: true,
    },
    {
      name: 'RESOURCE_FLEX_PORTAL_NEW_RESTRICTIONS_CUSTOMERS',
      enabled: true,
      contexts: {
        userId: ['b138c9f3-8de4-4a1d-b8eb-3f2a1dcba8e9'],
      },
    },
    {
      name: 'RESOURCE_FLEX_PORTAL_NEW_RESTRICTIONS_COUNTRIES',
      enabled: true,
      contexts: {
        countryCode: ['gr'],
      },
    },
    {
      name: 'FLEXPORTAL_USE_PORTFOLIOS_FROM_ACTIVATIONS_BFF',
      enabled: false,
    },
    {
      name: 'INTERNAL_RESOURCE_SYNC',
      enabled: true,
    },
    {
      name: 'RES_DISABLE_BY_LOCATION',
      enabled: true,
      contexts: {
        location: ['fi'],
      },
    },
    {
      name: 'DISABLE_STATUS_UPDATES_BY_RESOURCE_TYPE',
      enabled: true,
      contexts: {
        resourceType: ['FRONT_OF_THE_METER_BATTERY'],
      },
    },
    {
      name: 'FLEX_PORTAL_DRAWER_BID_OVERVIEW_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_FILTER_CONFLICTING_ACTIVATION_GROUPS',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_BID_CASCADING_MFRR_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_HUBSPOT_COMPANY_ID_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_BID_CASCADING_FCRD_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_BID_CASCADING_FCRN_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_ENABLE_IMPORT_ENERGY_OFFERS',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_TSV_CAPACITY_IMPORT',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_ACTIVATION_PLAN_PAGE_ENABLED',
      enabled: true,
    },
    {
      name: 'FLEX_PORTAL_DISTURBANCES_PAGE_ENABLED',
      enabled: false,
    },
    {
      name: 'FLEX_PORTAL_AMPTANK_AUTOMATED_MFRR_BIDDING_KILLSWITCH',
      enabled: false,
    },
  ].map((feature) => ({
    ...feature,
    impressionData: false,
  })),
}
